import { style } from '@vtex/admin-ui'

export const container = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingRight: '$space-2',
  height: '100%',
})
